import { OnInit, Injectable } from '@angular/core';
import { loadModules } from 'esri-loader';
import { Subscription, BehaviorSubject, Subject } from 'rxjs';
import { MapaService } from './MapaService.service';
import { datosLayers } from 'src/app/models/SicarMap/datosLayers.model';
import { datosModelo } from 'src/app/models/SicarMap/datosModelo.model';
import { AuthService } from './auth.service';
import { LogCapa } from 'src/app/models/SicarMap/LogCapa.model';
import { LogsService } from './LogsService.service';
import { LogEdicion } from 'src/app/models/SicarMap/LogEdicion.model';


@Injectable({
  providedIn: 'root',
})
export class FeactureService {

  public LayersDatosActivos = new BehaviorSubject<datosLayers[]>([]);
  public LayersDatosCensoCount = new Subject<any[]>();
  public LayersDatosCenso = new Subject<string>();

  CamposLyr: any[] = [];
  LyrsConf: any[] = [];

  DatosLayers: datosLayers[] = [];
  DatosModelosEjecutados: datosModelo[] = [];
  //mapaPrincipal: any;
  DatosDeuda = [];

  globalToken: any;


  constructor(
    private authService: AuthService,
    private servicioMapa: MapaService,
    private ServicioLogs: LogsService
  ) {
    this.servicioMapa.MapaBaseComplete.asObservable().subscribe((data: any) => {
      if (data) {
        //this.mapaPrincipal = this.servicioMapa.mapaSource;
      }
    });
  }

  async getToken(ServAuth){

    const [IdentityManager] = await loadModules(['esri/identity/IdentityManager']);

    await ServAuth.getTokenPortal().subscribe((data)=>{
     //console.log(data);
     this.globalToken = data.token;
      IdentityManager.registerToken({
        token: data.token,
        server: 'https://arcgisoucportal.aguapuebla.mx/arcgis/sharing',
        ssl: true,
      });
    });
  }


  inicializarLayers(layers: any[]) {
    layers.forEach(layer => {
      this.inicializaLayer(layer);
    });

    this.getToken(this.authService)
  }

  async inicializaLayer(layer) {
    //console.log(layer.camposCartografia)
    try {
      let version = 'sde.DEFAULT';
      const [EsriFeatureLayer] = await loadModules(['esri/layers/FeatureLayer']);
      let labelClass = null;
      if (layer.labelActiva) {
        labelClass = [this.GenerarLabelClass(layer.label)];
      }

      let template = null;
      if (layer.toolTipActivo) {
        template = this.GenerarToolTip(layer.pidcartografia, layer.tituloToolTip ? layer.tituloToolTip : '', layer.camposCartografia);
      }

      if (layer.editar || layer.eliminar || layer.agregar) {
        //version = 'Edicion';
        this.servicioMapa.ConfiguracionLayers.push({
          layer: layer.pidcartografia + '_ItemCarto',
          Agregar: layer.agregar,
          Edicion: layer.editar,
          Eliminacion: layer.eliminar,
          Exportar: layer.exportar,
          Validacion: layer.validar
        });
      }
      const OpcionesLayer = {
        url: layer.sfeatureServer,
        id: layer.pidcartografia + '_ItemCarto', /*  + layer.nombreCarto , */
        title: layer.snombreCarto,
        labelingInfo: labelClass,
        mode: EsriFeatureLayer.MODE_SELECTION,
        outFields: ['*'],
        popupTemplate: template,
        hasM: false,
        gdbVersion: version
      };

      const featureLayer = new EsriFeatureLayer(OpcionesLayer);
      featureLayer.on("edits", async (evento) => {
        // console.log(featureLayer);
        let resultsData = [];
        await this.ObtenerRegistrosCenso(featureLayer.parsedUrl.path).then((Informacion) => {
          resultsData = Informacion;
        });
        this.LogsEdiciones(evento, featureLayer.id)
        this.LayersDatosCensoCount.next(resultsData);
        this.LayersDatosCenso.next(featureLayer.parsedUrl.path);
      });
      return featureLayer;
    } catch (error) {
      console.log('EsriLoader: ', error);
    }
  }

  LogsEdiciones(evento, capa) {
    const IdCapa = capa.split('_')[0];
    // console.log("Edicion", evento, capa);
    if (evento.addedFeatures.length > 0) {
      const ID = evento.addedFeatures[0].objectId
      this.ServicioLogs.RegitrarLogEdicion(new LogEdicion(this.authService.Usuario.pidusuario, "Agregar", IdCapa, ID, '')).subscribe(data => { });
    }
    if (evento.updatedFeatures.length > 0) {
      const ID = evento.updatedFeatures[0].objectId
      this.ServicioLogs.RegitrarLogEdicion(new LogEdicion(this.authService.Usuario.pidusuario, "Modificar", IdCapa, ID, '')).subscribe(data => { });
    }
    if (evento.deletedFeatures.length > 0) {
      const ID = evento.deletedFeatures[0].objectId
      this.ServicioLogs.RegitrarLogEdicion(new LogEdicion(this.authService.Usuario.pidusuario, "Eliminar", IdCapa, ID, '')).subscribe(data => { });
    }
  }

  async inicializaLayerEscenario(layer) {
    try {
      const [EsriFeatureLayer] = await loadModules(['esri/layers/FeatureLayer']);
      let labelClass = null;
      if (layer.slabel) {
        labelClass = [this.GenerarLabelClass(layer.slabel)];
      }
      let template = null;
      if(layer.toolTipActivo){
        template = this.GenerarToolTip(layer.fidcarto, layer.tituloToolTip ? layer.tituloToolTip : '', layer.escenarioCampos);
      }

      const OpcionesLayer = {
        url: layer.fidcartoNavigation.sfeatureServer,
        id: layer.pidcartoEscenario + '_Escenario',
        title: layer.fidcartoNavigation.snombreCarto,
        //definitionExpression: layer.sfiltroCarto,
        labelingInfo: labelClass,
        outFields: ['*'],
        popupTemplate: template
      };
      const featureLayer = new EsriFeatureLayer(OpcionesLayer);
      featureLayer.minScale = layer.nscaleMin;
      featureLayer.maxScale = layer.nscaleMax;
      featureLayer.opacity = layer.fopacity;
      return featureLayer;
    } catch (error) {
      console.log('EsriLoader: ', error);
    }
  }

  GenerarLabelClass(Etiqueta) {
    let Campos = Etiqueta.split(',');
    let EtiquetaC = '';
    Campos.forEach(element => {
      if (EtiquetaC == "") {
        EtiquetaC += "$feature[\"" + element + "\"]";
      } else {
        EtiquetaC = EtiquetaC + "+ ' ' +$feature[\"" + element + "\"]"; /* '\\n' + */
      }
      //console.log(EtiquetaC)
    });
    return {
      symbol: {
        type: 'text',  // autocasts as new TextSymbol()
        color: 'black',
        haloColor: 'white',
        haloSize: 2,
        font: {  // autocast as new Font()
          family: 'Playfair Display',
          size: 12,
          weight: 'bold'
        }
      },
      //labelPlacement: 'center-along',
      //labelExpression : Etiquetale,
      labelExpressionInfo: {
        expression: EtiquetaC
      }
    };
  }
  GenerarToolTip(LayerID, Titulo, Campos: any[]) {
    let actions;
    Campos.filter(e => {
      // if ((e.scampo.toUpperCase().includes('NIS') || e.scampo.toUpperCase().includes('NISRAD'))) {
    });
    actions = this.ObtenerActionsTooltip(LayerID, Campos);
    //console.log(Campos)
    return {  // Enable a popup
      title: '<span>' + Titulo + '<span>', // Mostrar atributo como {Titulo}
      content: [{
        type: 'fields',
        fieldInfos: this.GenerarFielInfos(Campos, true) // Mostrar texto de ToolTip'{Direccion} , {Horario}',
      },
      {
        type: "attachments", // AttachmentsContentElement
        attachmentInfos: [{ displayType: "preview" }]
      }],
      actions
    };
  }

  ObtenerActionsTooltip(layerID, Campos: any) {
    let actions = [];
    // Campos.filter(e => {
    //   // if ((e.scampo.toUpperCase().includes('NIS') || e.scampo.toUpperCase().includes('NISRAD'))) {
    //   if ((e.scampo === 'NIS' || e.scampo === 'NISRAD')) {
    //     actions.push({
    //       title: "Consultar NISS",
    //       id: "searchniss-this",
    //       className: "esri-icon-search"
    //     });
    //   }
    // });

    if(layerID == 11 || layerID == 97 || layerID == 182) {
      actions.push({
        title: "Consultar NISS",
        id: "searchniss-this",
        className: "esri-icon-search"
      });
    }
    // actions.push({
    //   title: "StreetView NISS",
    //   id: "viewstreetniss-this",
    //   className: "esri-icon-navigation"
    // });
    return actions;
  }

  GenerarFielInfos(valoresCC: any[], tooltip: boolean) {
    const FieldInfos: any[] = [];
    if (tooltip) {
      valoresCC.filter((item) => item.btooltip).forEach((item) => {
        FieldInfos.push({
          fieldName: item.scampo,
          label: item.salias
        });
      });
    } else {
      valoresCC.forEach((item) => {
        FieldInfos.push({
          fieldName: item.scampo,
          label: item.salias
        });
      });
    }
    return FieldInfos;
  }

  GenerarFielInfosTabla(valoresCC: any[]) {
    const FieldInfos: any[] = [];
    valoresCC.forEach((item) => {
      FieldInfos.push({
        name: item.campo,
        label: item.alias
      });
    });
    return FieldInfos;
  }

  agregarDatosLayer(clave: string, nombre: string, datos: any, campos: any[], url?: string, filtro?: string) {
    this.DatosLayers.push(new datosLayers(clave, nombre, datos, campos, url, filtro));
    this.LayersDatosActivos.next(this.DatosLayers);
  }

  eliminarDatosLayer(clave: string) {
    if (this.DatosLayers.find(x => x.id === clave)) {
      this.DatosLayers.splice(this.DatosLayers.indexOf(this.DatosLayers.find(x => x.id === clave)), 1);
      this.LayersDatosActivos.next(this.DatosLayers);
    }
  }

  agregarCamposLayer(clave: string, capa: string, campos: any[]) {
    this.CamposLyr.push({ id: clave, capa, campos });
  }

  eliminarCamposLayer(clave: string) {
    if (this.CamposLyr.find(x => x.id === clave)) {
      this.CamposLyr.splice(this.CamposLyr.indexOf(this.CamposLyr.find(x => x.id === clave)), 1);
    }
  }

  eliminarSeleccionLayer(clave: string) {
    if (this.servicioMapa.RegLyrSelect.find(x => x.id === clave)) {
      this.servicioMapa.RegLyrSelect.splice(this.servicioMapa.RegLyrSelect.indexOf(this.servicioMapa.RegLyrSelect.find(x => x.id === clave)), 1);
    }
  }

  async ObtenerRegistrosLayer(layer, condicion: string) {
    try {
      const [Query] = await loadModules(['esri/tasks/support/Query']);
      const query = new Query();
      query.returnGeometry = true;
      query.token =this.globalToken;
      query.outFields = ['*'];
      query.where = condicion;
      return layer.queryFeatures(query).then((results) => {
        return results;
      });
    } catch (error) {
      console.log('EsriLoader: ', error);
    }
  }

  async ObtenerRegistrosUrl(url: string, condicion: string, campos?) {
    try {
      const [Query, QueryTask, FeatureLayer] = await loadModules(
        ['esri/tasks/support/Query', 'esri/tasks/QueryTask', 'esri/layers/FeatureLayer']);
      const qTask = new QueryTask({
        url
      });
      const query = new Query();
      query.token = this.globalToken;
      query.returnGeometry = true;
      if (campos) {
        query.outFields = campos;
      } else {
        query.outFields = ['*'];
      }
      query.orderByFields = ["OBJECTID DESC"];
      if (this.servicioMapa.AreaTrabajo.length > 0) {
        query.spatialRelationship = 'intersects';
        query.geometry = this.servicioMapa.AreaTrabajo[0].geometry;
      }
      query.outSpatialReference = {
        wkid: 4326
      };
      query.where = condicion;
      return qTask.execute(query).then((results) => {
        results.features.forEach(Item => {
          if (Item.attributes.hasOwnProperty('FECHA_REVISION') || Item.attributes.hasOwnProperty('FECHA_SUPERVISION') || Item.attributes.hasOwnProperty('FECHA_GENERACION') || Item.attributes.hasOwnProperty('FECHA_PROGRAMADA') || Item.attributes.hasOwnProperty('FECHA_RESOLUCION') || Item.attributes.hasOwnProperty('FECHA_ANULACION') || Item.attributes.hasOwnProperty('FECHA_LEVANTAMIENTO')|| Item.attributes.hasOwnProperty('created_date') || Item.attributes.hasOwnProperty('last_edited_date') || Item.attributes.hasOwnProperty('fecha') || Item.attributes.hasOwnProperty('Fecha'))  {
            if ((Item.attributes.FECHA_REVISION) && (Item.attributes.FECHA_REVISION != null)) {
              Item.attributes.FECHA_REVISION = new Date(Item.attributes.FECHA_REVISION).toLocaleString('es-MX');
            }
            if ((Item.attributes.FECHA_SUPERVISION) && (Item.attributes.FECHA_SUPERVISION != null)) {
              Item.attributes.FECHA_SUPERVISION = new Date(Item.attributes.FECHA_SUPERVISION).toLocaleString('es-MX');
            }
            if ((Item.attributes.FECHA_GENERACION) && (Item.attributes.FECHA_GENERACION != null)) {
              Item.attributes.FECHA_GENERACION = new Date(Item.attributes.FECHA_GENERACION).toLocaleString('es-MX');
            }
            if ((Item.attributes.FECHA_PROGRAMADA) && (Item.attributes.FECHA_PROGRAMADA != null)) {
              Item.attributes.FECHA_PROGRAMADA = new Date(Item.attributes.FECHA_PROGRAMADA).toLocaleString('es-MX');
            }
            if ((Item.attributes.FECHA_RESOLUCION) && (Item.attributes.FECHA_RESOLUCION != null)) {
              Item.attributes.FECHA_RESOLUCION = new Date(Item.attributes.FECHA_RESOLUCION).toLocaleString('es-MX');
            }
            if ((Item.attributes.FECHA_ANULACION) && (Item.attributes.FECHA_ANULACION != null)) {
              Item.attributes.FECHA_ANULACION = new Date(Item.attributes.FECHA_ANULACION).toLocaleString('es-MX');
            }
            if ((Item.attributes.FECHA_LEVANTAMIENTO) && (Item.attributes.FECHA_LEVANTAMIENTO != null)) {
              Item.attributes.FECHA_LEVANTAMIENTO = new Date(Item.attributes.FECHA_LEVANTAMIENTO).toLocaleString('es-MX');
            }
            if ((Item.attributes.created_date) && (Item.attributes.created_date != null)) {
              Item.attributes.created_date = new Date(Item.attributes.created_date).toLocaleString('es-MX');
            }
            if ((Item.attributes.last_edited_date) && (Item.attributes.last_edited_date != null)) {
              Item.attributes.last_edited_date = new Date(Item.attributes.last_edited_date).toLocaleString('es-MX');
            }
            if ((Item.attributes.fecha) && (Item.attributes.fecha != null)) {
              Item.attributes.fecha = new Date(Item.attributes.fecha).toLocaleString('es-MX');
            }
            if ((Item.attributes.Fecha) && (Item.attributes.Fecha != null)) {
              Item.attributes.Fecha = new Date(Item.attributes.Fecha).toLocaleString('es-MX');
            }
          }
        });
        return results.features;
      }).catch((error) => {
        console.log('query task error', error);
      });
    } catch (error) {
      console.log('EsriLoader: ', error);
    }
  }

  async ObtenerRegistrosCenso(urlFeature: string = '', urlMap: string = '') {
    try {
      const resultsData = [];
      const [Query, QueryTask, FeatureLayer] = await loadModules(
        ['esri/rest/support/Query', 'esri/tasks/QueryTask', 'esri/layers/FeatureLayer']);
      const qTask = new QueryTask({
        url: urlFeature
      });
      const query = new Query();
      query.token = this.globalToken;
      query.where = '1>=1';
      if (this.servicioMapa.AreaTrabajo.length > 0) {
        query.spatialRelationship = 'intersects';
        query.geometry = this.servicioMapa.AreaTrabajo[0].geometry;
      }
      query.outFields = ['ESTADO_REVISION'];
      query.returnGeometry = false;
      query.returnDistinctValues = false;
      query.returnIdsOnly = false;
      query.returnCountOnly = false;
      query.returnExtentOnly = false;
      query.groupByFieldsForStatistics = 'ESTADO_REVISION';
      query.outStatistics = [
        {
          "statisticType": "count",
          "onStatisticField": "ESTADO_REVISION",
          "outStatisticFieldName": "StatusByStateofRevision"
        }
      ];
      return qTask.execute(query).then((results) => {
        if (results.features) {
          const features = results.features;
          features.forEach(element => {
            const attributes = element.attributes;
            resultsData.push(attributes)
          });
          this.LayersDatosCenso.next(urlFeature);
          return resultsData;
        } else {
          console.log('not done obtain information');
        }
      }).catch((error) => {
        console.log('not done obtain information', error);
      });
    } catch (error) {
      console.log('EsriLoader: ', error);
    }
  }

  async ObtenerRegistrosArea(layer) {
    const [Query] = await loadModules(['esri/tasks/support/Query']);
    const query = new Query();
    query.token = this.globalToken;
    query.returnGeometry = false;
    query.spatialRelationship = 'intersects';
    query.geometry = this.servicioMapa.AreaTrabajo[0].geometry;
    return layer.queryObjectIds(query).then((results) => {
      return results;
    }).catch((error) => {
      throw error;
    });
  }

  async ObtenerGeometrias(layer, condicion = '1=1', campos = [], geometria?, Rspacial = 'intersects', Ids = false) {
    const [Query] = await loadModules(['esri/tasks/support/Query']);
    const query = new Query();
    query.token = this.globalToken;
    query.where = condicion;
    query.outFields = campos;
    query.returnGeometry = !Ids;
    if (geometria) {
      query.spatialRelationship = Rspacial;
      query.geometry = geometria;
    } else if (this.servicioMapa.AreaTrabajo.length > 0) {
      query.spatialRelationship = Rspacial;
      query.geometry = this.servicioMapa.AreaTrabajo[0].geometry;
    }

    if (query.spatialRelationship == "relation") {
      query["relationParameter"] = "FF*FF****"
    }
    return layer.queryFeatures(query).then((results) => {
      return results;
    }).catch((error) => {
      throw error;
    });
  }

  async ValidarPoligonoArea(Geometry) {
    try {
      const [geometryEngine] = await loadModules(['esri/geometry/geometryEngine']);
      let valido = geometryEngine.contains(this.servicioMapa.AreaTrabajo[0].geometry, Geometry);
      if (valido) {
        return Geometry;
      } else {
        let DifGeo = geometryEngine.difference(Geometry, this.servicioMapa.AreaTrabajo[0].geometry);
        let GeoInte = geometryEngine.difference(Geometry, DifGeo);
        return GeoInte;
      }
    } catch (error) {
      throw error;
    }
  }

  async UnificarDeuda(Suministros, Deuda) {
    try {
      let AvisoAvance = 0;
      let contador = 0;
      let suministrosC = [];
      Suministros.forEach((ItmG) => {
        let deudaI = Deuda.find((IDS) => IDS.nis === ItmG.NISRAD);
        if (deudaI) {
          let graphic = {
            geometry: ItmG.GEOMETRIA,
            symbol: {
              type: 'simple-marker',
              color: 'blue',
              size: 8,
              outline: {
                width: 0.5,
                color: 'darkblue'
              }
            },
            attributes: {
              NISRAD: ItmG.NISRAD,
              MONTO: deudaI.monto,
              PERIODOS: deudaI.periodos
            }
          }
          suministrosC.push(graphic);
        }
        AvisoAvance++;
        contador++;
        if (AvisoAvance === 1000) {
          AvisoAvance = 0;
        }
      });
      return suministrosC;
    } catch (error) {
      console.log('EsriLoader: ', error);
      return error;
    }
  }

  async ObtenerRegistrosSuministros(geometria: any) {
    try {
      const [Query, QueryTask, geometryEngine] = await loadModules(
        ['esri/tasks/support/Query', 'esri/tasks/QueryTask', 'esri/geometry/geometryEngine']);

      if (this.servicioMapa.AreaTrabajo.length > 0) {
        let valido = geometryEngine.contains(this.servicioMapa.AreaTrabajo[0].geometry, geometria);
        if (!valido) {
          let DifGeo = geometryEngine.difference(geometria, this.servicioMapa.AreaTrabajo[0].geometry);
          let GeoInte = geometryEngine.difference(geometria, DifGeo);
          geometria = GeoInte;
        }
      }

      let urlsuministros = this.servicioMapa.Servicios.find(x => x.servicio == "Usuarios");
      const qTask = new QueryTask({ url: urlsuministros.urlServicio });
      const query = new Query();
      query.token = this.globalToken;
      query.spatialRelationship = 'contains';
      query.geometry = geometria;
      query.returnGeometry = true;
      query.outFields = ['*'];
      query.outSpatialReference = {
        wkid: 4326
      };
      return qTask.execute(query).then((results) => {
        let graficos = []
        results.features.forEach((IG) => {
          graficos.push({
            OBJECTID: IG.attributes.OBJECTID,
            NISRAD: IG.attributes.NISRAD,
            GEOMETRIA: {
              type: 'point',
              x: IG.geometry.x,
              y: IG.geometry.y,
              spatialReference: {
                wkid: 4326
              }
            }
          });
        });
        return graficos;
      }).catch((error) => {
        console.log('query task error', error);
      });
    } catch (error) {
      console.log('EsriLoader: ', error);
    }
  }

  async GenerarFeatureRender(graficos: any[], ClassT: any[], CampoTematizado: string, IdLayer: string, campos: any[], nomModelo: string) {
    try {
      const layerB = this.servicioMapa.mapaSource.findLayerById(IdLayer);
      if (layerB !== undefined) {
        this.servicioMapa.mapaSource.remove(layerB);
      }

      const template = {  // Enable a popup
        title: '<span>' + nomModelo + '<span>', // Mostrar atributo como {Titulo}
        content: [{
          type: 'fields',
          fieldInfos: this.GenerarFielInfosArray(campos)  // Mostrar texto de ToolTip'{Direccion} , {Horario}'
        }]
      };
      const [FeatureLayer] = await loadModules(['esri/layers/FeatureLayer']);
      const renderer = {
        type: 'class-breaks', // autocasts as new ClassBreaksRenderer()
        field: CampoTematizado,
        legendOptions: {
          title: nomModelo
        },
        defaultSymbol: {
          type: 'simple-fill', // autocasts as new SimpleFillSymbol()
          color: 'transparent',
          style: 'solid',
          outline: {
            width: 0.5,
            color: [50, 50, 50, 0.6]
          }
        },
        defaultLabel: 'no data',
        classBreakInfos: this.GenerarBrakeInfos(ClassT)
      };

      const FieldsObt: any[] = [];
      campos.forEach((item) => {
        FieldsObt.push({
          name: item.scampo,
          alias: item.salias,
          type: item.stipo
        });
      });
      const layer = new FeatureLayer({
        source: graficos,
        renderer,
        opacity: 0.65,
        id: IdLayer,
        title: nomModelo,
        objectIdField: 'OBJECTID',
        fields: FieldsObt,
        popupTemplate: template
      });
      this.servicioMapa.mapaSource.add(layer, this.servicioMapa.mapaSource.allLayers.length - 6);
      return layer;
    } catch (error) {
      console.log('EsriLoader: ', error);
    }
  }

  async GenerarFeatureSuministrosDeuda(graficos: any[]) {
    try {
      const layerB = this.servicioMapa.mapaSource.findLayerById('SuministrosDeuda');
      if (layerB !== undefined) {
        this.servicioMapa.mapaSource.remove(layerB);
      }

      const template = {  // Enable a popup
        title: '<span>Deuda<span>', // Mostrar atributo como {Titulo}
        content: [{
          type: 'fields',
          fieldInfos: [{
            fieldName: 'MONTO',
            label: 'MONTO'
          }, {
            fieldName: 'PERIODOS',
            label: 'PERIODOS'
          }, {
            fieldName: 'NISRAD',
            label: 'NIS'
          }]  // Mostrar texto de ToolTip'{Direccion} , {Horario}'
        }]
      };
      const [FeatureLayer] = await loadModules(['esri/layers/FeatureLayer']);
      const renderer = {
        type: 'class-breaks',  // autocasts as new ClassBreaksRenderer()
        field: 'PERIODOS',
        classBreakInfos: [{
          minValue: 0,
          maxValue: 0,
          symbol: {
            type: 'simple-marker',
            size: 6,
            color: 'green',
            outline: {
              width: 0.5,
              color: 'black'
            }
          }
        }, {
          minValue: 1,
          maxValue: 10,
          symbol: {
            type: 'simple-marker',
            size: 6,
            color: 'yellow',
            outline: {
              width: 0.5,
              color: 'black'
            }
          }
        }, {
          minValue: 11,
          maxValue: 200,
          symbol: {
            type: 'simple-marker',
            size: 6,
            color: 'red',
            outline: {
              width: 0.5,
              color: 'black'
            }
          }
        }]
      };

      const FieldsObt = [{
        name: 'MONTO',
        alias: 'MONTO',
        type: 'double'
      }, {
        name: 'PERIODOS',
        alias: 'PERIODOS',
        type: 'double'
      }, {
        name: 'NISRAD',
        alias: 'NIS',
        type: 'oid'
      }];
      const layer = new FeatureLayer({
        source: graficos,
        renderer,
        opacity: 0.65,
        id: 'SuministrosDeuda',
        title: 'Deuda por suministro',
        objectIdField: 'NISRAD',
        fields: FieldsObt,
        popupTemplate: template
      });
      this.servicioMapa.mapaSource.add(layer, this.servicioMapa.mapaSource.allLayers.length - 6);
      return layer;
    } catch (error) {
      console.log('EsriLoader: ', error);
    }
  }

  GenerarFielInfosArray(campos) {
    const FieldInfos: any[] = [];
    campos.filter((item) => item.btooltip).forEach((item) => {
      FieldInfos.push({
        fieldName: item.scampo,
        label: item.salias
      });
    });
    return FieldInfos;
  }

  GenerarBrakeInfos(RangosTematizacion: any[]) {
    const BrakeInfos: any[] = [];
    RangosTematizacion.forEach(element => {
      BrakeInfos.push({
        minValue: element.fvalorI,
        maxValue: element.fvalorF,
        symbol: {
          type: 'simple-fill', // autocasts as new SimpleFillSymbol()
          color: element.svalorTema,
          style: 'solid',
          outline: {
            width: 0.2,
            color: [255, 255, 255, 0.5]
          }
        },
        label: element.rangoInicial + ' a ' + element.rangoFinal
      });
    });
    return BrakeInfos;
  }

  EliminarFeatureLayer(IdLayer: string) {
    this.servicioMapa.mapaSource.remove();
    const layerB = this.servicioMapa.mapaSource.findLayerById(IdLayer);
    if (layerB !== undefined) {
      this.servicioMapa.mapaSource.remove(layerB);
    }
  }

  async GenerarAreaTrabajo(layer) {
    const [FeatureFilter] = await loadModules(['esri/layers/support/FeatureFilter']);
    this.servicioMapa.view.whenLayerView(layer)
      .then((layerView) => {
        layerView.filter = new FeatureFilter({
          geometry: this.servicioMapa.AreaTrabajo[0].geometry
        });
      }).catch(console.error);
  }

  async GenerarFiltroEliminados(layer) {
    const [FeatureFilter] = await loadModules(['esri/layers/support/FeatureFilter']);
    this.servicioMapa.view.whenLayerView(layer)
      .then((layerView) => {
        layerView.filter = new FeatureFilter({
          where: "ELIMINAR = 'NO'"
        });
      }).catch(console.error);
  }


  async ProcesarCombinacion(Datos, updateResultado: (value: any) => void) {
    if (typeof Worker !== 'undefined') {
      const worker = new Worker('../../app.worker', { type: 'module' });
      worker.onmessage = (data) => {
        updateResultado(data);
      };
      worker.postMessage(Datos);
      worker.onerror = (event) => {
        console.log('error', event);
      };
      worker.addEventListener('message', (evt) => {
        console.log('error', evt);
      });
    } else {
      // Web Workers are not supported in this environment.
      // You should add a fallback so that your program still executes correctly.
    }
  }
}
